module.exports = __webpack_public_path__ + "img/ty.d54c843b.png";